<template>
  <div class="content">
    <div class="card-box data-table">
      <div class="inp-list">
        <div class="item">
          <span class="label">{{ $t('g.operator') }}</span>
          <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.valOperator"
            :props="formData.props" :options="render.cascade_options_direct" />
        </div>
        <div class="item">
          <span class="label">{{ $t('device.site_name') }}</span>
          <el-input v-model="formData.valSiteName" :placeholder="$t('device.site_name')"></el-input>
        </div>
      </div>
      <div class="btn-ct">
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
        <el-button @click="func.showAddDataDialog" type="primary" class="btn-add">{{ $t('g.added') }}</el-button>
      </div>
      <div class="line"></div>
      <el-table @row-click.self="func.showDetails" :data="formData.tableData" style="width: 100%">
        <el-table-column prop="Id" label="ID" width="60">
        </el-table-column>
        <el-table-column prop="Name" :label="$t('device.site_name')" width="140">
        </el-table-column>
        <el-table-column prop="AgentCode" :label="$t('g.agent_code')" v-if="!isOperator()">
        </el-table-column>
        <el-table-column prop="CodePath" :label="$t('g.operator_ownership')" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column :label="$t('siteManager.operational_status')">
          <template #default="scope">
            <el-tag :class="scope.row.Status == 1 ? 'tag-success' : 'tag-fail'">
              {{ scope.row.Status == 1 ? $t('siteManager.at_camp') : $t('siteManager.stop_business') }}
            </el-tag>

          </template>
        </el-table-column>
        <el-table-column prop="PageView" :label="$t('siteManager.view_count')">
        </el-table-column>
        <el-table-column prop="Address" :label="$t('siteManager.detailed_address')">
        </el-table-column>
        <el-table-column prop="OperationTime" :label="$t('siteManager.opening_hours')">
        </el-table-column>
        <el-table-column prop="CreateAtStr" min-width="180" :label="$t('g.create_at')">
        </el-table-column>
        <el-table-column width="180" :label="$t('g.operation')" fixed="right">
          <template #default="scope">
            <el-button @click="func.delete(scope.row.Id)" class="btn-delete" type="primary"
              style="margin-left: 10px;">{{ $t('g.delete') }}</el-button>
            <el-button @click="func.edit(scope.row)" class="btn-edit" type="primary">{{
              $t('g.edit')
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <span class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize
        }}</span>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="$t('g.edit')" v-model="formData.dialogVisible" width="90%" align-center>

      <el-form label-width="100px" :model="formData.curData">
        <div class="box_flex">
          <el-form-item :label="$t('device.site_name')" style="width: 50%;">
            <el-input v-model="formData.curData.Name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('siteManager.operational_status')">
            <el-radio-group v-model="formData.curData.Status">
              <el-radio :value="1" size="large">{{ $t('siteManager.at_camp') }}</el-radio>
              <el-radio :value="0" size="large">{{ $t('siteManager.stop_business') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="box_flex">
          <el-form-item :label="$t('rights.agent')" v-if="isAdmin()" style="width: 50%;">
            <el-cascader style="width: 100%;" :clearable="true" v-model="formData.curData.AgentCode"
              :props="formData.props2" :options="render.cascade_options_direct" />
          </el-form-item>
          <el-form-item :label="$t('g.operator')" style="width: 50%;">
            <el-cascader style="width: 100%;" :clearable="true" v-model="formData.curData.CodePathID"
              :props="formData.props" :options="render.cascade_options_direct" />
          </el-form-item>
        </div>
        <div class="box_flex">
          <el-form-item :label="$t('siteManager.site_longitude')" style="width: 50%;">
            <el-input v-model="formData.curData.Longitude"></el-input>
          </el-form-item>
          <el-form-item :label="$t('siteManager.site_latitude')" style="width: 50%;">
            <el-input v-model="formData.curData.Latitude"></el-input>
          </el-form-item>
        </div>
        <div class="box_flex">
          <el-form-item :label="$t('siteManager.detailed_address')" style="width: 50%;">
            <el-input v-model="formData.curData.Address"></el-input>
          </el-form-item>
          <el-form-item :label="$t('siteManager.opening_hours')" style="width: 50%;">
            <el-input v-model="formData.curData.OperationTime" :placeholder="$t('siteManager.site_txt1')"></el-input>
          </el-form-item>
        </div>

        <div class="box_flex">
          <el-form-item :label="$t('workOrder.service_number')" style="width: 50%;">
            <el-input v-model="formData.curData.SiteManagerNum"></el-input>
          </el-form-item>
          <el-form-item :label="$t('siteManager.service_type')" style="width: 50%;">
            <el-input v-model="formData.curData.ServiceTypeTab"></el-input>
          </el-form-item>
        </div>
        <div class="box_flex">
          <el-form-item :label="$t('siteManager.site_introduction')" style="width: 100%;">
            <el-input v-model="formData.curData.SiteExplain" type="textarea" :rows="2"></el-input>
          </el-form-item>
        </div>
        <div class="box_flex">
          <el-form-item> 注：站点图片最大一张500kB,缩略图最大一张20kB</el-form-item>
        </div>
        <div class="box_flex" v-show="formData.form_type == 'edit'">
          <el-form-item :label="$t('siteManager.site_images')">
            <el-upload class="avatar-uploader" action="/admin/device/ImgsUp" list-type="picture-card" method="post"
              :limit="4" :headers="{ Authorization: token }" :http-request="(params) => func.onUpload(params, 0)"
              :beforeUpload="func.beforeImgUpload1" :show-file-list="false">
              <img v-if="formData.dataImg.Img0" :src="formData.dataImg.Img0" class="avatar" />
              <el-icon v-else class="avatar-uploader-icon">
                <Plus />
              </el-icon>
            </el-upload>
            <el-upload class="avatar-uploader" action="/admin/device/ImgsUp" list-type="picture-card" method="post"
              :limit="4" :headers="{ Authorization: token }" :http-request="(params) => func.onUpload(params, 1)"
              :beforeUpload="func.beforeImgUpload1" :show-file-list="false" style="margin-left: 20px;">
              <img v-if="formData.dataImg.Img1" :src="formData.dataImg.Img1" class="avatar" />
              <el-icon v-else class="avatar-uploader-icon">
                <Plus />
              </el-icon>
            </el-upload>
            <el-upload class="avatar-uploader" action="/admin/device/ImgsUp" list-type="picture-card" method="post"
              :limit="4" :headers="{ Authorization: token }" :http-request="(params) => func.onUpload(params, 2)"
              :beforeUpload="func.beforeImgUpload1" :show-file-list="false" style="margin-left: 20px;">
              <img v-if="formData.dataImg.Img2" :src="formData.dataImg.Img2" class="avatar" />
              <el-icon v-else class="avatar-uploader-icon">
                <Plus />
              </el-icon>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('siteManager.thumbnails')">
            <div style="display: flex;">
              <el-upload class="avatar-uploader" action="/admin/device/ImgsUp" list-type="picture-card" method="post"
                :limit="4" :headers="{ Authorization: token }" :beforeUpload="func.beforeImgUpload2"
                :http-request="(params) => func.onUpload(params, 3)" :show-file-list="false">
                <img v-if="formData.dataImg.Img3" :src="formData.dataImg.Img3" class="avatar" />
                <el-icon v-else class="avatar-uploader-icon">
                  <Plus />
                </el-icon>
              </el-upload>
            </div>
          </el-form-item>
        </div>

      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="func.updateData()">{{ $t('g.btn_confirm') }}</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog :title="$t('g.detail')" v-model="formData.dialogDetailVisible" width="80%" style="padding: 20px 30px;"
      align-center>
      <el-descriptions border>
        <el-descriptions-item :label="$t('device.site_name')">{{
          formData.curData.Name
        }}</el-descriptions-item>

        <el-descriptions-item :label="$t('g.operator')">{{
          formData.curData.CodePath
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('siteManager.view_count')">
          <el-tooltip class="item" effect="dark" content="相同用户一天只记访问一次，不重复计算" placement="top-start">
            <el-tag> {{
              formData.curData.PageView
            }}</el-tag>
          </el-tooltip>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('siteManager.operational_status')">
          <el-tag :class="formData.curData.Status == 1 ? 'tag-success' : 'tag-fail'"> {{
            formData.curData.Status == 1 ? $t('siteManager.at_camp') : $t('siteManager.stop_business')
          }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('siteManager.site_longitude')">{{
          formData.curData.Longitude
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('siteManager.site_latitude')">{{
          formData.curData.Latitude
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('siteManager.opening_hours')">{{
          formData.curData.OperationTime
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('siteManager.service_type')">{{
          formData.curData.ServiceTypeTab
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('workOrder.service_number')">{{
          formData.curData.SiteManagerNum
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('siteManager.detailed_address')">{{
          formData.curData.Address
        }}</el-descriptions-item>


        <el-descriptions-item :label="$t('g.create_at')">{{
          formData.curData.CreateAtStr
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.update_at')">{{
          formData.curData.UpdateAtStr
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('siteManager.site_introduction')">{{
          formData.curData.SiteExplain
        }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, onMounted, computed, watch } from 'vue'
import { operators, updateOperators, shortcuts, operatorList, cascade_options_direct } from '@/data/default'
import { toDay } from '@/common/func'
import city from '@/common/city.json'
import axios from "axios"
import { ElMessage, ElMessageBox } from 'element-plus'
import i18n from '@/data/i18n/index'
import { isOperator, isPath, isAdmin, user } from '@/data/token'
import cfg from '@/common/conf'
export default {
  name: 'ExpensesCombo',
  setup() {
    const t = i18n.global.t
    const tableData = []
    const render = {
      operators,
      shortcuts,
      cascade_options_direct
    }
    const formData = reactive({
      tableData,
      curData: {},
      strategyList: [],
      carStrategyInfo: {},
      valTime: '',
      valStatus: 0,
      valType: 0,
      dialogVisible: false,
      dialogDetailVisible: false,
      dialogDisplayVisible: false,
      CodePathID: 0,
      curPage: 1,
      pageSize: 10,
      total: 500,
      valOperator: 0,
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "Id",
        emitPath: false,
        checkStrictly: true
      },
      props2: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "Code",
        emitPath: false,
        checkStrictly: true
      },
      addres_props: {
        children: "children", expandTrigger: 'hover',
        label: "name",
        value: "name",
        emitPath: true,
        checkStrictly: true
      },
      IsStartWith: 1,
      activeName: 'first',
      time_slot: [],
      timeInfo: [],
      form_type: 'add',
      fileList: [],
      uploadVisible: false,
      dialogImageUrl: '',
      dataImg: {
        Img0: '',
        Img1: '',
        Img2: '',
        Img3: '',
      },
    })
    onMounted(() => {
      func.loadData()
    })
    const func = {
      search() {
        console.log('formData', formData)
        func.loadData()
      },
      beforeImgUpload1(file) {

        const isLt500K = file.size / 1024 < 500;
        if (!isLt500K) {
          ElMessage({
            type: 'error',
            message: '图片大小不能超过500KB!'
          })
          return false
        }
      },
      beforeImgUpload2(file) {

        const isLt20K = file.size / 1024 < 20;
        if (!isLt20K) {
          ElMessage({
            type: 'error',
            message: '图片大小不能超过20KB!'
          })
          return false
        }
      },
      async showDetails(row, column) {
        if (column && column.label == t('g.operation')) {
          return;
        }
        formData.curData = row;
        formData.dialogDetailVisible = true;
      },
      handlePictureCardPreview(uploadFile) {
        formData.dialogImageUrl.value = uploadFile.url
        formData.uploadVisible.value = true
      },
      edit(row, column, e) {
        formData.curData = row
        delete formData.curData.DevId
        formData.form_type = 'edit'
        func.getImage()
        formData.activeName = 'first'
        formData.dialogVisible = true
      },
      async getImage() {
        formData.dataImg = {
          Img0: '',
          Img1: '',
          Img2: '',
          Img3: '',
        }
        let res = await axios.post('/admin/lifeservice/imgget', {
          SiteCode: formData.curData.SiteCode
        })
        if (res) {
          if (res.Img0) {
            formData.dataImg.Img0 = 'data:image/bmp;base64,' + res.Img0;
          }
          if (res.Img1) {
            formData.dataImg.Img1 = 'data:image/bmp;base64,' + res.Img1;
          }
          if (res.Img2) {
            formData.dataImg.Img2 = 'data:image/bmp;base64,' + res.Img2;
          }
          if (res.Img3) {
            formData.dataImg.Img3 = 'data:image/bmp;base64,' + res.Img3;
          }
        }
      },
      async onUpload(data, type) {
        let fd = new FormData();
        let headers = {
          'Content-Type': 'multipart/form-data'
        }
        fd.append('Img', data.file)
        fd.append('ImgName', type)
        fd.append('SiteCode', formData.curData.SiteCode)
        let res = await axios.post('/admin/pilesite/imgup', fd, { headers })
        func.getImage()
      },
      async delete(Id) {
        ElMessageBox.confirm(t('g.sure_delete'), {
          confirmButtonText: t('confirm'),
          cancelButtonText: t('cancel'),
        }).then(() => {
          try {
            axios.post('/admin/lifeservice/del', {
              Id
            }).then((res) => {
              if (res == '删除成功') {
                ElMessage({
                  type: 'success',
                  message: t('g.success')
                })
              } else {
                ElMessage({
                  type: 'error',
                  message: t("err_code.20005")
                })
              }
              func.loadData()
            })

          } catch (error) {
            ElMessage({
              type: 'error',
              message: t("err_code.20005")
            })
          }

        })
      },

      pageChange(val) {
        console.log('page change', val)
        func.loadData(val)
      },
      showAddDataDialog() {
        formData.curData = {
          Name: '',
          Longitude: '',
          Latitude: '',
          Status: 1,
          Address: '',
          OperationTime: '',
        }
        formData.form_type = 'add'
        formData.activeName = 'first'
        formData.carStrategyInfo = {}
        formData.dialogVisible = true
      },
      async updateData() {
        try {
          let params = Object.assign({}, formData.curData)
          // params.ProvinceAndCity = JSON.stringify(formData.curData.ProvinceAndCity)
          console.log(JSON.stringify(formData.curData.CodePathID), 21376);

          params.CodePathID = formData.curData.CodePathID ? formData.curData.CodePathID : ''
          params.AgentCode = formData.curData.AgentCode ? formData.curData.AgentCode : ''
          params.Lon = formData.curData.Longitude
          params.Lat = formData.curData.Latitude

          if (formData.form_type == 'edit') {
            params.Id = formData.curData.Id
            await axios.post('/admin/lifeservice/edit', params)
          } else {
            await axios.post('/admin/lifeservice/add', params)
          }
        } catch (e) {

        }
        formData.dialogVisible = false
        func.loadData()
      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page

          let params = {
            page,
          }
          if (formData.valOperator) {
            params.CodePathID = formData.valOperator
          }
          if (formData.valSiteName) {
            params.Name = formData.valSiteName
          }
          let res = await axios.get(`/admin/lifeservice/get`, {
            params
          })

          console.log('列表信息', res)
          formData.total = res.Total
          res.List.map((item) => {
            item.CreateAtStr = toDay(item.CreateAt)
            item.UpdateAtStr = item.UpdateAt ? toDay(item.UpdateAt) : ''
          })
          formData.tableData = res.List
          formData.PageSize = res.PageSize
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }

    return {
      func,
      render,
      isOperator,
      isAdmin,
      formData,
      isPath,
      city,
      uploadUrl: cfg.uploadUrl,
      token: user.token,
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  box-sizing: border-box;
  padding: 1.25rem;

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;
    margin-bottom: 1.25rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }

    >.btn-ct {
      text-align: right;

      :deep(.el-button--small) {
        padding: 0.625rem 2rem;
      }
    }

    .inp-list {
      display: grid;
      margin: 0 auto;
      margin-top: 1rem;
      grid-template-columns: repeat(4, 24.1%);
      gap: 14px 16px;

      >.item {
        display: flex;
        align-items: center;


        .label {
          display: flex;
          justify-content: left;
          min-width: 76px;
        }

        :deep(.el-range-editor--small.el-input__inner) {
          flex: 1;
        }

        .inp {
          flex: 1;
        }
      }
    }
  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }

  >.data-table {
    :deep(.el-table) {
      .cell {
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .el-table__row {
        cursor: pointer;
      }
    }
  }

  >.pagination {
    text-align: right;
    margin-top: 1.25rem;
  }

  .el-form-row {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;

    :deep(.el-form-item) {
      width: 33%;
    }

    .inp {
      width: 100%;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }

  :deep(.m-dialog) {
    max-width: 50rem;
  }
}

.box_flex {
  display: flex;
}

.tabs {
  margin-bottom: 30px;
}

:deep .el-tabs--card>.el-tabs__header {
  border-top: 0px solid #e4e7ed !important;
}

:deep .el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: 1px solid #e4e7ed !important;
}

:deep .el-tabs--card>.el-tabs__header {
  background-color: #fff !important;
}


.form-row {
  text-align: left;
  // padding: 0 60px;
  margin-top: 45px;

  .inp {
    width: 500px;
  }

  .inp_right {
    margin-right: 15px;
  }

  .label_box {
    display: flex;
    margin-bottom: 15px
  }

  .title_label {
    width: 100px;
    text-align: right;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }

  .money_box {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  .time_money {
    margin-top: 30px
  }
}

.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

:deep .avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

:deep .avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

:deep .el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}
</style>